import React from "react";
import { getBalancePointsString } from "../../../helpers/prizes-shop";

import "./style.scss";

const ShopOrder = ({ $locale, prize }) => {
    if (!prize) {
        return null;
    }

    const available = prize.inStock ? (prize.totalLimit - prize.totalSold) : 0;
    const photo = prize.images?.[0]?.previewFileUrl;

    return (
        <div className="shop-order">
            <div className="shop-order-image-container">{photo && <img alt="" src={photo} />}</div>
            <div className="shop-order-info-container">
                <div className="shop-order-info-available">
                    {$locale.get('shop.available')} {available} / {prize.totalLimit}
                </div>
                <div className="shop-order-info-title">{$locale.getProperty(prize, 'title')}</div>
                <div className="shop-order-info-price">
                    {getBalancePointsString({$locale, price: parseInt(prize.price)})}
                </div>
            </div>
        </div>
    );
};

export default ShopOrder;
